// react
import React from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

class LogFilesPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
    }
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }))
  }

  render() {
    let { modalOpen } = this.state

    return (
      <div id="log-files-page">
        <Header
          title="Log Files"
          actions={[
            {
              children: 'Create New Log File',
              onClick: this.toggleModal,
            },
          ]}
        />

        <ListView
          columns={[
            {
              key: 'name',
              link: '/log-files/:_id',
              sortable: true,
            },
            {
              key: 'bucket',
              sortable: true,
            },
            {
              key: 'rotate_interval',
              name: 'Rotate Interval',
            },
            {
              key: 'description',
              name: 'Description',
            },
          ]}
          entities="log-files"
          fields={['name', 'bucket', 'rotate_interval', 'description']}
          filters={[]}
          searchable={true}
          sort_key={'name'}
          sort_dir={1}
        />
        <Dialog open={modalOpen} close={this.toggleModal}>
          <NewEntityDialog
            close={this.toggleModal}
            entities="log-files"
            title="Enter a name for your new Log File"
          />
        </Dialog>
      </div>
    )
  }
}

// export
export default LogFilesPage
